<template>
<v-container v-if="permitted == false && permitted != null" class="pt-0" fluid>
  <v-dialog v-model="permitted_dialog" max-width="400px">
    <v-card>
      <v-card-text>
        <div class="text-center">
          <div class="title font-weight-light pt-2"><v-icon class="mr-1">mdi-shield-lock-outline</v-icon>Security Error</div>
          <p>{{message}}</p>
          <v-progress-circular
            :size="70"
            :width="2"
            :value="100"
            color="error"
            class="mb-4 mr-4"
          >
            <v-icon color="red" x-large>mdi-exclamation-thick</v-icon>
          </v-progress-circular>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</v-container>
<v-container v-else v-show="permitted != null" class="pt-0" fluid>
  <v-snackbar
    :value="showMessage()"
    multi-line
    color="#686868"
    top
    
  >
    {{message}}
  </v-snackbar>
  <v-card flat >
  <v-toolbar dense flat color="#2A353D">
    <v-toolbar-title class="white--text subtitle-1 font-weight-normal">Application Defaults</v-toolbar-title>
    <v-spacer/>
    <v-btn fab x-small outlined color="#81DBF6" class="mr-1" v-if="edit == true || create == true" @click="view = false; closeCreate(); closeEdit()"><v-icon>mdi-chevron-left</v-icon></v-btn>
    <v-btn fab x-small outlined color="#81DBF6" @click="$router.push('/Home')"><v-icon>mdi-close</v-icon></v-btn>
  </v-toolbar>
  </v-card>

  <v-card elevation="12" class="mt-2">
    <v-form class="edit rounded-t-xl" ref="form" v-model="valid" lazy-validation>
      <v-toolbar dense flat color="#DBEFFA">
        <v-toolbar-title class="grey--text subtitle-1 font-weight-normal">Settings</v-toolbar-title>
        <v-spacer/>
      </v-toolbar>
      <v-row class="ml-1 mr-1">
      <v-col>
        <v-select
          filled dense
          v-model="allApplicationDefaults[0].CurrencyID"
          :items="allCurrencies.filter(a => a.CheckerID != 0 && a.RejectionID == 0)"
          item-text="CurrencyName"
          item-value="CurrencyID"
          label="Active Currency"
        ></v-select>
        <v-select
          filled dense
          v-model="allApplicationDefaults[0].CallAccountTypeID"
          :items="allCallAccountTypes.filter(a => a.CheckerID != 0 && a.RejectionID == 0)"
          item-text="CallAccountType"
          item-value="CallAccountTypeID"
          label="Call Account Type"
        ></v-select>
        <v-select
          filled dense
          v-model="allApplicationDefaults[0].AccountStatusID"
          :items="allAccountStatuses.filter(a => a.CheckerID != 0 && a.RejectionID == 0)"
          item-text="AccountStatusDescription"
          item-value="AccountStatusID"
          label="Account Status"
        ></v-select>
        <v-select
          filled dense
          v-model="allApplicationDefaults[0].PropertyStatusID"
          :items="allPropertyStatuses.filter(a => a.CheckerID != 0 && a.RejectionID == 0)"
          item-text="PropertyStatus"
          item-value="PropertyStatusID"
          label="Property Status"
        ></v-select>
        <v-select
          filled dense
          v-model="allApplicationDefaults[0].CustodianStatusID"
          :items="allCustodianStatuses.filter(a => a.CheckerID != 0 && a.RejectionID == 0)"
          item-text="CustodianStatusDescription"
          item-value="CustodianStatusID"
          label="Custodian Status"
        ></v-select>
      </v-col>
      <v-col>
        <v-select
          filled dense
          v-model="allApplicationDefaults[0].ReportingCurrencyId"
          :items="allCurrencies.filter(a => a.CheckerID != 0 && a.RejectionID == 0)"
          item-text="CurrencyName"
          item-value="CurrencyID"
          label="Reporting Currency"
        ></v-select> 
        <v-select
          filled dense
          v-model="allApplicationDefaults[0].UnitsRoundingID"
          :items="allUnitsRounding.filter(a => a.CheckerID != 0 && a.RejectionID == 0)"
          item-text="Rounding"
          item-value="UnitsRoundingID"
          label="Units Rounding"
        ></v-select>
        <v-text-field
          light dense filled
          color="#2A353D"
          v-model="allApplicationDefaults[0].UnitsPrecision"
          label="Units Precision"
          required
          :rules="TextFieldRules"
        ></v-text-field>
        <v-text-field
          light dense filled
          color="#2A353D"
          v-model="allApplicationDefaults[0].PricePrecision"
          label="Price Precision"
          required
          :rules="TextFieldRules"
        ></v-text-field>
        <v-checkbox
          v-model="allApplicationDefaults[0].AlwaysAskCurrency"
          class="mt-0"
          label="Always ask currency for Asset Deals and Call Transactions OR DO NOT TICK to use the active Currency as the default?"
        ></v-checkbox>
      </v-col>
      <v-col>
        <v-row>
          <v-col class="pb-0 pt-0">
            <v-text-field
              light dense filled
              color="#2A353D"
              v-model="allApplicationDefaults[0].BackdatingLimitValue"
              label="Backdating Limit"
              required
              :rules="TextFieldRules"
            ></v-text-field>
          </v-col>
          <v-col class="pb-0 pt-0">
            <v-select
              filled dense
              v-model="allApplicationDefaults[0].BackdatingLimitPeriodID"
              :items="allBackdatingLimitPeriods.filter(a => a.CheckerID != 0 && a.RejectionID == 0)"
              item-text="Period"
              item-value="BackdatingLimitPeriodID"
              label="(within a period)"
            ></v-select> 
          </v-col>
        </v-row>
        <v-select
          filled dense
          v-model="allApplicationDefaults[0].SecurityUserId"
          :items="allUsers.filter(a => a.CheckerID != 0)"
          item-text="FullName"
          item-value="SecurityUserID"
          label="Backdating Authoriser"
        ></v-select>
        <v-checkbox
          v-model="allApplicationDefaults[0].AllowBackdating"
          class="mt-0"
          label="Allow Backdating?"
        ></v-checkbox>
        <v-checkbox
          v-model="allApplicationDefaults[0].OeSettleAuthorisation"
          class="mt-0"
          label="Override Settlement Authorisation?"
        ></v-checkbox>
        <v-checkbox
          v-model="allApplicationDefaults[0].ActivateUtPayments"
          class="mt-0"
          label="Upload Unit Trust Payments?"
        ></v-checkbox>
        <v-checkbox
          v-model="allApplicationDefaults[0].OverRideBalanceChecks"
          class="mt-0"
          label="Override Balance Checks?"
        ></v-checkbox>
        <v-checkbox
          v-model="allApplicationDefaults[0].ChangeOverRideEnabled"
          class="mt-0"
          label="Enable Change/Edit Override?"
        ></v-checkbox>
        <div class="text-right">
          <v-btn class="white--text" small color="#2A353D" :disabled="!valid" @click="update()">save</v-btn>          
        </div>
      </v-col>
      </v-row>
      <v-divider class="mt-0"/>
    </v-form>
  </v-card>

</v-container>
</template>

<script>
import {mapGetters, mapActions} from "vuex";
import UserService from '../services/user.service';

export default {
  name: 'application_defaults',

  data () {
    return {
      message: '',
      valid: true,
      permitted: null,
      permitted_dialog: true,
      content: '',
      TextFieldRules: [
        v => !!v || 'field is required',
      ],
    }
  },

  computed: {
    ...mapGetters([
      "allApplicationDefaults",
      "allCurrencies",
      "allCallAccountTypes",
      "allAccountStatuses",
      "allPropertyStatuses",
      "allCustodianStatuses",
      "allUnitsRounding",
      "allBackdatingLimitPeriods",
      "allUsers",
      "allConfirmationSettings"
    ]),
    currentUser() {
      return this.$store.state.auth.user;
    },
    showEditBtn() {
    for (let i = 0; i < this.currentUser.roles.length; i++) {
      if (this.currentUser.roles[i].role_name.map(r => r.role_permission.filter(r => r.FunctionID === 406).map(r => r.AllowEdit)) == 1){
        return true
      }
    }
    return false;
    },

    showCreateBtn() {
    for (let i = 0; i < this.currentUser.roles.length; i++) {
      if (this.currentUser.roles[i].role_name.map(r => r.role_permission.filter(r => r.FunctionID === 406).map(r => r.AllowCreate)) == 1){
        return true
      }
    }
    return false;
    },

    showConfirmBtn() {
    for (let i = 0; i < this.currentUser.roles.length; i++) {
      if (this.currentUser.roles[i].role_name.map(r => r.role_permission.filter(r => r.FunctionID === 406).map(r => r.AllowConfirm)) == 1){
        return true
      }
    }
    return false;
    },

    CheckerID(){
      if(this.allConfirmationSettings.filter(a => a.FunctionID == 406).map(a => a.Status)[0] == false){
        return this.currentUser.SecurityUserID
      } else {
        return 0
      }
    }
  },

  methods: {
    ...mapActions([
      "updateApplicationDefaults",
    ]),

    async update() {
      this.message = '';
      await this.validate();
      if(this.valid == true){
        this.allApplicationDefaults[0].LastUserID = this.currentUser.SecurityUserID,

        this.updateApplicationDefaults(this.allApplicationDefaults[0])
        .then(response => {
          this.$socket.client.emit('socketreq', {
            commit: 'updApplicationDefaults',
            data: this.allApplicationDefaults[0]
          });
          
          this.message = response.data.message
          this.closeEdit()
        },
        error => {
        this.message =
          (error.response && error.response.data.message) ||
          error.message ||
          error.toString();
        })
      }
    },

    showEdit () {
      this.edit = true
    },

    closeEdit() {
      this.edit = false
    },

    showCreate () {
      this.create = true
    },

    closeCreate() {
      this.create = false
    },

    showMessage(){
      if(this.message){
        return true
      } else {
        return false
      }
    },

    validate () {
      this.$refs.form.validate()
    },

    reset () {
      this.$refs.form.reset()
    },
  },

  mounted () {
    UserService.isSystemDefaults().then(
      () => {
        this.permitted = true;
        this.message = '';
      },
      error => {
        this.permitted = false;
        this.message =
          (error.response && error.response.data.message) ||
          error.message ||
          error.toString();
      }
    );
  }
}
</script>

<style scoped>
.list {
  text-align: left;
  max-width: 750px;
  margin: auto;
}

.v-btn {
  outline: none
}

.edit {
  background-color: #DBEFFA;
}

.headline {
  color:white
}
</style>
